import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'

export default class Order extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/order`)
  }

  detail(orderId, showProgress) {
    return this._request({
      action: `${orderId}/detail`,
      method: 'GET',
      showProgress
    })
  }

  brief(orderId, showProgress) {
    return this._request({
      action: `${orderId}/brief`,
      method: 'GET',
      showProgress
    })
  }

  calculatePrice(orderId, showProgress) {
    return this._request({
      action: `${orderId}/price`,
      method: 'GET',
      showProgress
    })
  }

  cancel(model, showProgress) {
    const { id } = model
    delete model.id

    return this._request({
      action: id,
      method: 'DELETE',
      body: model,
      showProgress
    })
  }

  // change order steps
  setAsOngoing(orderId, showProgress) {
    return this._request({
      action: `${orderId}/preProcess`,
      method: 'PATCH',
      showProgress
    })
  }

  start(orderId, showProgress) {
    return this._request({
      action: `${orderId}/start`,
      method: 'PATCH',
      showProgress
    })
  }

  start‌Branch(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/start/branch`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  finish(orderId, showProgress) {
    return this._request({
      action: `${orderId}/finish`,
      method: 'PATCH',
      showProgress
    })
  }
  // ----------

  revertAcceptTariff(orderId, showProgress) {
    return this._request({
      action: `${orderId}/revert/accept/tariff`,
      method: 'PATCH',
      showProgress
    })
  }

  revertAcceptAuction(orderId, showProgress) {
    return this._request({
      action: `${orderId}/revert/accept/auction`,
      method: 'PATCH',
      showProgress
    })
  }

  revertAssignCourierDriver(orderId, showProgress) {
    return this._request({
      action: `${orderId}/revert/assignCourierDriver`,
      method: 'PATCH',
      showProgress
    })
  }

  revertStart(orderId, showProgress) {
    return this._request({
      action: `${orderId}/revert/start`,
      method: 'PATCH',
      showProgress
    })
  }

  revertFinish(orderId, showProgress) {
    return this._request({
      action: `${orderId}/revert/finish`,
      method: 'PATCH',
      showProgress
    })
  }
  // ----------

  // update order price
  updateExcess(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/excess`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  updateAuctionPrice(orderId, model) {
    return this._request({
      action: `${orderId}/pricing/auction`,
      body: model,
      method: 'PATCH'
    })
  }
  // ----------

  recordWeighbridge(orderId, point, model, showProgress) {
    return this._request({
      action: `${orderId}/weighbridge/${point}`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  assignCourierDriver(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/assignCourierDriver`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  reassignCourierDriver(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/reassignCourierDriver`,
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  acceptDriver(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/acceptDriver`,
      body: model,
      method: 'PATCH',
      showProgress
    })
  }

  // update order parts
  updateFurnitureInfo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/info/furniture`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateCargoInfo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/info/cargo`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateFreightInfo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/info/freight`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateMaterialInfo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/info/material`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateTrashInfo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/info/trash`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateOrigin(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/origin`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateDestinationCargo(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/destination/cargo`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateDestinationFreight(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/destination/freight`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateDestinationFurniture(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/destination/furniture`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updateDestinationTrash(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/destination/trash`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }
  updateCars(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/car`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  updateItem(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/item`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  updateEmployees(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/employee`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  updatePackageTypes(orderId, model, showProgress) {
    return this._request({
      action: `${orderId}/packageType`,
      body: model,
      method: 'PUT',
      showProgress
    })
  }

  // ----------
}
